/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerMaintenanceRulesResponseDto } from './PartnerMaintenanceRulesResponseDto';
import {
    PartnerMaintenanceRulesResponseDtoFromJSON,
    PartnerMaintenanceRulesResponseDtoFromJSONTyped,
    PartnerMaintenanceRulesResponseDtoToJSON,
    PartnerMaintenanceRulesResponseDtoToJSONTyped,
} from './PartnerMaintenanceRulesResponseDto';

/**
 * 
 * @export
 * @interface ListPartnerMaintenanceRulesResponseDto
 */
export interface ListPartnerMaintenanceRulesResponseDto {
    /**
     * 
     * @type {Array<PartnerMaintenanceRulesResponseDto>}
     * @memberof ListPartnerMaintenanceRulesResponseDto
     */
    items: Array<PartnerMaintenanceRulesResponseDto>;
}

/**
 * Check if a given object implements the ListPartnerMaintenanceRulesResponseDto interface.
 */
export function instanceOfListPartnerMaintenanceRulesResponseDto(value: object): value is ListPartnerMaintenanceRulesResponseDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ListPartnerMaintenanceRulesResponseDtoFromJSON(json: any): ListPartnerMaintenanceRulesResponseDto {
    return ListPartnerMaintenanceRulesResponseDtoFromJSONTyped(json, false);
}

export function ListPartnerMaintenanceRulesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPartnerMaintenanceRulesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(PartnerMaintenanceRulesResponseDtoFromJSON)),
    };
}

export function ListPartnerMaintenanceRulesResponseDtoToJSON(json: any): ListPartnerMaintenanceRulesResponseDto {
    return ListPartnerMaintenanceRulesResponseDtoToJSONTyped(json, false);
}

export function ListPartnerMaintenanceRulesResponseDtoToJSONTyped(value?: ListPartnerMaintenanceRulesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(PartnerMaintenanceRulesResponseDtoToJSON)),
    };
}

